import { render } from "./Ekipa.vue?vue&type=template&id=ffcbc5e6&scoped=true"
const script = {}

import "./Ekipa.vue?vue&type=style&index=0&id=ffcbc5e6&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffcbc5e6"]])

export default __exports__